import { Stack } from 'react-bootstrap';
import { BsShieldX } from 'react-icons/bs';

interface ForbiddenProps {
  message?: string;
  title?: string;
}

/**
 * Forbidden access component for RBAC enforcement
 * Displays when user attempts to access a resource without proper permissions
 */
export const Forbidden = ({
  title = 'Access Denied',
  message = "You don't have permission to access this resource"
}: ForbiddenProps) => {
  return (
    <Stack
      className="justify-content-center align-items-center"
      gap={3}
      style={{ minHeight: '60vh', padding: '2rem' }}
    >
      <BsShieldX
        size={64}
        className="text-secondary"
        style={{ opacity: 0.6 }}
      />
      <h2 className="text-secondary fw-semibold mb-0">{title}</h2>
      <p className="text-muted text-center mb-0">{message}</p>
    </Stack>
  );
};
